import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types";
import { ContactInfo } from "./ContactInfo";
import { FinanceRate } from "./FinanceRate";
import { FlowType } from "./FlowType";
import { LeadApplicant } from "./LeadApplicant";
import { LeadQuote } from "./LeadQuote";
import { LeadTrade } from "./LeadTrade";
import { Metadata } from "./Metadata";
import { Money } from "./Money";

export const Lead = t.intersection([
  t.type({
    expired_at: DateFromISOString,
    connected: t.array(t.string),
    accepted: t.array(t.string),
    status: t.union([
      t.literal("issued"),
      t.literal("open"),
      t.literal("credit_declined"),
      t.literal("quote_declined"),
      t.literal("trade_notified"),
      t.literal("trade_accepted"),
      t.literal("trade_declined"),
      t.literal("expired"),
      t.literal("closed"),
    ]),
    source: t.union([t.literal("consumer"), t.literal("checkout")]),
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    oid: t.string,
    aid: t.string,
    eid: t.string,
    bid: t.string,
    tid: t.string,
    invite_info: ContactInfo,
    lead_applicant: LeadApplicant,
    lead_quote: LeadQuote,
    lead_trade: LeadTrade,
    finance_options: t.array(FinanceRate),
    budget: Money,
    max_credit_amount: Money,
    xid: t.string,
    xref: t.string,
    flow_type: FlowType,
    referrer: t.string,
    metadata: Metadata,
  }),
]);

export interface Lead {
  id?: string;
  cid?: string;
  oid?: string;
  aid?: string;
  eid?: string;
  bid?: string;
  tid?: string;
  invite_info?: ContactInfo;
  lead_applicant?: LeadApplicant;
  lead_quote?: LeadQuote;
  lead_trade?: LeadTrade;
  finance_options?: Array<FinanceRate>;
  budget?: Money;
  max_credit_amount?: Money;
  expired_at: Date;
  xid?: string;
  xref?: string;
  connected: Array<string>;
  accepted: Array<string>;
  status:
    | "issued"
    | "open"
    | "credit_declined"
    | "quote_declined"
    | "trade_notified"
    | "trade_accepted"
    | "trade_declined"
    | "expired"
    | "closed";
  flow_type?: FlowType;
  source: "consumer" | "checkout";
  referrer?: string;
  metadata?: Metadata;
}
